<template>
  <v-card flat>
    <v-container>
      <v-row dense no-gutters class="mb-2 mx-2">
        <v-col cols="12" md="8">
          <v-container>
            <v-row dense>
              <v-col cols="12" class="mb-2">
                <div class="title">{{ t("color.title") }}</div>
              </v-col>
              <v-col cols="12" md="6">
                <sc-color-field
                  :title="t('color.icon.label')"
                  v-model="primaryColor"
                ></sc-color-field>
              </v-col>
              <v-col cols="12" md="6">
                <sc-color-field
                  :title="t('color.btnBackground.label')"
                  v-model="btnBackground"
                ></sc-color-field>
              </v-col>
              <v-col cols="12" md="6">
                <sc-color-field
                  :title="t('color.background.label')"
                  v-model="background"
                ></sc-color-field>
              </v-col>
              <v-col cols="12" md="6">
                <sc-color-field
                  :title="t('color.text.label')"
                  v-model="btnColor"
                ></sc-color-field>
              </v-col>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </v-container>
  </v-card>
</template>

<script>
import { mapFields } from "vuex-map-fields";
export default {
  computed: {
    ...mapFields("designer", [
      "model.settings.primaryColor",
      "model.settings.btnBackground",
      "model.settings.background",
      "model.settings.btnColor",
    ]),
  },

  methods: {
    t(key, options = {}) {
      return this.$t(`designer.colors.${key}`, options);
    },
  },
};
</script>

<style></style>
